module.exports = __webpack_public_path__ + "img/baumann.8f596ec2.png";